import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Shield } from 'lucide-react';

const Privacy = () => {
  const sections = [
    { title: '1. 信息收集', content: '我们收集您在注册、使用服务时提供的信息，包括但不限于：邮箱地址、旅行偏好、行程规划数据、打卡照片等。这些信息将用于为您提供个性化服务。' },
    { title: '2. 信息使用', content: '您的信息将严格用于：生成旅行攻略、保存行程数据、提供个性化推荐、改进产品体验。我们承诺不会将您的个人信息出售给第三方。' },
    { title: '3. 信息安全', content: '我们采用行业标准的安全措施保护您的数据，包括数据加密、访问控制、定期安全审计等。您的密码经过加密存储，我们无法获取明文密码。' },
    { title: '4. Cookie使用', content: '我们使用Cookie技术来识别您的身份、记录登录状态、分析使用行为。您可以在浏览器设置中管理Cookie偏好。' },
    { title: '5. 第三方服务', content: '我们使用Supabase作为后端服务提供商，您的数据存储在其安全的云基础设施中。我们使用的AI服务提供商也遵循严格的隐私保护协议。' },
    { title: '6. 数据删除', content: '您有权随时删除您的账号及所有关联数据。删除后数据将在30天内从我们的系统中完全清除。' },
    { title: '7. 政策更新', content: '我们可能会不定期更新隐私政策。重大变更时，我们会通过邮件或站内通知告知您。继续使用服务即表示您同意更新后的政策。' },
    { title: '8. 联系我们', content: '如果您对隐私政策有任何疑问，请通过 privacy@cattravellog.com 联系我们。' },
  ];

  return (
    <div className="min-h-screen bg-bg-primary">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white mb-4">
            <Shield className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-4xl font-bold text-text-primary mb-4 tracking-tight">隐私政策</h1>
          <p className="text-sm text-text-secondary">最后更新日期：2024年1月1日</p>
        </div>

        <Card className="border-0 shadow-card rounded-card bg-white">
          <CardContent className="p-8 space-y-6">
            <p className="text-text-primary leading-relaxed">西蒙的猫旅行日记（"我们"）非常重视用户隐私保护。本隐私政策说明了我们如何收集、使用、存储和保护您的个人信息。</p>
            {sections.map((section, idx) => (
              <div key={idx}>
                <h2 className="text-lg font-semibold text-text-primary mb-3">{section.title}</h2>
                <p className="text-text-secondary leading-relaxed">{section.content}</p>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Privacy;
